import React from 'react';

const CoreValues = () => (
  <section id="projects" className="g-pt-75 g-pb-45">
    <div className="container">
      <header className="g-mb-20">
        <div className="u-heading-v2-3--bottom g-brd-primary g-mb-10">
          <h2 className="h4 u-heading-v2__title g-color-gray-dark-v2 g-font-weight-600 text-uppercase g-mt-minus-10 g-mb-5">
            The Path of Love, Obedience, and Salvation
          </h2>
        </div>
        <p className="g-font-size-16">
          Love, obedience, and salvation form the foundation of a life rooted in
          Christ. Through salvation we are brought into relationship with God,
          through love we reflect His heart to others, and through obedience we
          walk daily in His will and purpose.
        </p>
      </header>

      <div className="row">
        {/* Salvation */}
        <div className="col-lg-4 col-md-6 g-mb-30">
          <article className="u-block-hover u-shadow-v21 rounded">
            <figure className="u-bg-overlay g-bg-black-opacity-0_4--after">
              <img
                className="img-fluid w-100 u-block-hover__main--zoom-v1"
                src="/images/obedience.png"
                alt="Illustration representing salvation"
              />
            </figure>
            <header className="u-bg-overlay__inner g-pos-abs g-top-30 g-right-30 g-left-30 g-color-white">
              <h3 className="h4">
                <a className="g-color-white" href="#">
                  Salvation
                </a>
              </h3>
              <p>Romans 10:9</p>
            </header>
            <ul className="list-inline u-bg-overlay__inner g-pos-abs g-bottom-10 g-left-30 g-opacity-0_8">
              <li className="list-inline-item g-color-white">
                &quot;If you declare with your mouth, &apos;Jesus is Lord,&apos; and
                believe in your heart that God raised him from the dead, you will be
                saved.&quot;
              </li>
            </ul>
          </article>
        </div>

        {/* Love */}
        <div className="col-lg-4 col-md-6 g-mb-30">
          <article className="u-block-hover u-shadow-v21 rounded">
            <figure className="u-bg-overlay g-bg-black-opacity-0_4--after">
              <img
                className="img-fluid w-100 u-block-hover__main--zoom-v1"
                src="/images/love.png"
                alt="Illustration representing love"
              />
            </figure>
            <header className="u-bg-overlay__inner g-pos-abs g-top-30 g-right-30 g-left-30 g-color-white">
              <h3 className="h4">
                <a className="g-color-white" href="#">
                  Love
                </a>
              </h3>
              <p>John 3:16–17</p>
            </header>
            <ul className="list-inline u-bg-overlay__inner g-pos-abs g-bottom-10 g-left-30 g-opacity-0_8">
              <li className="list-inline-item g-color-white">
                &quot;For God so loved the world that he gave his one and only Son...&quot;
              </li>
            </ul>
          </article>
        </div>

        {/* Obedience */}
        <div className="col-lg-4 col-md-6 g-mb-30">
          <article className="u-block-hover u-shadow-v21 rounded">
            <figure className="u-bg-overlay g-bg-black-opacity-0_4--after">
              <img
                className="img-fluid w-100 u-block-hover__main--zoom-v1"
                src="/images/salvation.png"
                alt="Illustration representing obedience"
              />
            </figure>
            <header className="u-bg-overlay__inner g-pos-abs g-top-30 g-right-30 g-left-30 g-color-white">
              <h3 className="h4">
                <a className="g-color-white" href="#">
                  Obedience
                </a>
              </h3>
              <p>2 John 1:6</p>
            </header>
            <ul className="list-inline u-bg-overlay__inner g-pos-abs g-bottom-10 g-left-30 g-opacity-0_8">
              <li className="list-inline-item g-color-white">
                &quot;This is love: that we walk in obedience to his commands.&quot;
              </li>
            </ul>
          </article>
        </div>
      </div>
    </div>
  </section>
);

export default CoreValues;
